import { useEffect } from 'react';
import { usePushStore } from '../store/pushStore';

export function usePushListener() {
  const set = usePushStore((s) => s.set);

  // useEffect(() => {
  // // Сразу кладём тестовый payload
  //   set({
  //       eventId: 42,
  //       imageUrl: 'https://picsum.photos/400/300',
  //       eventTime: new Date().toISOString(),
  //   });
  //   }, []);

  useEffect(() => {
    // 1. postMessage от SW (вкладка была открыта)
    const onMessage = (e: MessageEvent) => {
        console.log('SW message:', e.data);

      if (e.data?.type === 'PUSH_EVENT') set(e.data.payload);
    };
    navigator.serviceWorker?.addEventListener('message', onMessage);

    // 2. URL-параметр (вкладка была закрыта, открылась по клику)
    const params = new URLSearchParams(location.search);
    const eventId = params.get('push_event');
    if (eventId) {
      // Грузим данные события по id
      fetch(`/api/events/${eventId}`)
        .then((r) => r.json())
        .then((data) => set(data));

      // Чистим URL сразу
      history.replaceState({}, '', location.pathname);
    }

    return () => {
      navigator.serviceWorker?.removeEventListener('message', onMessage);
    };
  }, []); // только при маунте
}